const URL_BASE=process.env.REACT_APP_API;

export const URL_ROLES_LIST=`${URL_BASE}/hotmers/role`;